import { NativeDatePicker, Select, Text } from "components/base/Form";
import { useContext } from "react";
import ProjectContext from "./ProjectContext";

const BasicInfoView = () => {
  const { originalProject, project, onChange } = useContext(ProjectContext);

  return (
    <div className="card">
      <div className="space-y-6">
        {originalProject.version > 1 && (
          <div>
            <h5>Version Description</h5>
            <Text
              className="mt-2 -mx-1"
              value={project.versionInfo}
              onChange={(e) =>
                onChange({ project: { versionInfo: e.target.value } })
              }
              placeholder="Enter version description"
            />
          </div>
        )}

        <div>
          <h5>Goal</h5>
          <Text
            className="mt-2 -mx-1"
            value={project.goal}
            onChange={(e) => onChange({ project: { goal: e.target.value } })}
            placeholder="Enter project goal"
          />
        </div>

        <div>
          <h5>Timeline</h5>
          <div className="mt-3 flex gap-3 flex-wrap">
            <div>
              <label className="pr-3">Start: </label>
              <NativeDatePicker
                value={project.startDate}
                onChange={(e) =>
                  onChange({ project: { startDate: e.target.value } })
                }
              />
            </div>

            <div>
              <label className="pr-3">Samples: </label>
              <NativeDatePicker
                value={project.sampleDate}
                onChange={(e) =>
                  onChange({ project: { sampleDate: e.target.value } })
                }
              />
            </div>

            <div>
              <label className="pr-3">Target Release: </label>
              <NativeDatePicker
                value={project.targetDate}
                onChange={(e) =>
                  onChange({ project: { targetDate: e.target.value } })
                }
              />
            </div>
          </div>

          <div className="mt-3 flex items-center space-x-3">
            <label>Priority</label>
            <Select
              value={project.priority}
              onChange={(e) =>
                onChange({ project: { priority: e.target.value } })
              }
            >
              <option value="2">🔴 High</option>
              <option value="1">🟡 Medium</option>
              <option value="0">🟢 Low</option>
            </Select>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BasicInfoView;
